import embed from '../embedReports/solarEmbed';
import slicer from '../slicerReports/solarSlicer';

const embedAndSlice = async (container, embedConfiguration) => {
  const pbiEmbed = await embed.getEmbed(container, embedConfiguration);
  try {
    const activePage = await getActivePage(pbiEmbed);
    const visuals = await activePage.getVisuals();

    await slicer.setSlicersForPage(
      activePage.displayName,
      embedConfiguration.reportParameters,
      visuals
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

const getActivePage = async (pbiEmbed) => {
  const pages = await pbiEmbed.getPages();

  return pages.filter((page) => page.isActive)[0];
};

export default {
  embedAndSlice,
};
